import React from "react";

export class ErrorPage extends React.Component {
    render() {
        return (
            <div>This is the error page...</div>
        )
    }
}
